import { model, models, Schema, Types } from "mongoose";
import { IPreset } from "./types";

const PresetSchema = new Schema<IPreset>(
  {
    chainId: { type: Number, required: true },
    packageIndex: { type: Number, required: true },
    presetIndex: { type: Number, required: true },
    totalSupply: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    decimals: {
      type: Number,
      default: 0,
      set: (value: string) => Number(value),
    },

    liquidity: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    marketCap: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    reserveETH: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
    reserveToken: {
      type: Schema.Types.Decimal128,
      default: new Types.Decimal128("0"),
    },
  },
  {
    toObject: {
      getters: true,
      versionKey: false,
      transform: (doc, ret: any) => {
        ret.id = ret._id.toString();
        delete ret._id;

        ret.totalSupply = ret.totalSupply.toString();
        ret.liquidity = ret.liquidity.toString();
        ret.marketCap = ret.marketCap.toString();
        ret.reserveETH = ret.reserveETH.toString();
        ret.reserveToken = ret.reserveToken.toString();

        return ret;
      },
    },
  }
);

PresetSchema.index({ chainId: 1, packageIndex: 1, presetIndex: 1 });

export const PresetModel =
  models?.Preset || model<IPreset>("Preset", PresetSchema);
